import { useClipboardChecklistCriteriaGenerator } from "./useClipboardChecklistCriteriaGenerator";

export const useClipboardChecklistSectionGenerator = (
    section: Section,
    allRows: any[],
    allCriteria: ChecklistCriteria[],
    isNested: boolean,
    numParagraphs: number,
    numParagraphColumns: number,
    cellTextToParagraphs: CellTextParagraphs[],
    showParagraphColumns: boolean = false
) => {
    var sectionRow = document.createElement("tr");

    if (isNested == true) {
        var bufferCell = document.createElement("td");
        bufferCell.style.border = "1px solid black";
        bufferCell.style.backgroundColor = "#F4F5F8";
        // Set width to 30px
        bufferCell.style.width = "30px";
        sectionRow.appendChild(bufferCell);
    }

    var columnSpan = 0;
    var numParagraphsToUse = numParagraphColumns;

    if (section.displayParagraphColumns) {
        columnSpan = isNested ? 1 : 2;
    } else {
        columnSpan = isNested ? 1 + numParagraphColumns : 2 + numParagraphColumns;
    }

    var sectionTitleCell = document.createElement("td");
    sectionTitleCell.innerText = section.title;
    sectionTitleCell.style.backgroundColor = "#F4F5F8";
    sectionTitleCell.style.fontWeight = "bold";
    sectionTitleCell.style.border = "1px solid black";
    sectionTitleCell.colSpan = columnSpan;
    sectionTitleCell.style.width = "auto";


    sectionRow.appendChild(sectionTitleCell);


    if (section.displayParagraphColumns) {
        var index = 1;

        var sectionParagraphPositionsData = section.paragraphPositionsData;

        var sectionColSpan = Math.floor(numParagraphColumns / numParagraphsToUse);

        var totalColumns = 0;


        var scoresRow = document.createElement("tr");


        while (index <= numParagraphsToUse) {
            totalColumns += sectionColSpan;

            var paragraphLabel = `P${index}`;

            if (
                sectionParagraphPositionsData &&
                sectionParagraphPositionsData[index - 1]
            ) {
                paragraphLabel = sectionParagraphPositionsData[index - 1].shortLabel;
            }

            // If the current key is the last keym and the total columns isn't yet equal to numParagraphs
            // Then we need to set columnSpan to the difference between numParagraphs and totalColumns
            if (
                index == numParagraphsToUse - 1 &&
                totalColumns != numParagraphColumns
            ) {
                sectionColSpan += numParagraphsToUse - totalColumns;
            }

            var scoreCell = document.createElement("td");
            scoreCell.innerText = paragraphLabel;
            scoreCell.style.textAlign = "center";
            scoreCell.style.fontWeight = "bold";
            scoreCell.style.backgroundColor = "#F4F5F8";
            scoreCell.style.fontSize = "12px";
            scoreCell.style.width = `${150 / numParagraphColumns}px`;
            scoreCell.style.border = "1px solid black";

            sectionRow.appendChild(scoreCell);

            index++;
        }


    }


    allRows.push(sectionRow);

    for (var criteriaInstance of section.criteriaInstances) {
        var criteriaRows = useClipboardChecklistCriteriaGenerator(
            criteriaInstance,
            allCriteria,
            numParagraphs,
            numParagraphColumns,
            cellTextToParagraphs
        );
        allRows.push(...criteriaRows);
    }

    if (section.sections) {
        for (var nestedSection of section.sections) {
            var copiedSection = { ...nestedSection };

            if (
                copiedSection.paragraphPositionsData == undefined &&
                section.paragraphPositionsData &&
                section.paragraphPositionsData.length > 0
            ) {
                copiedSection.paragraphPositionsData = section.paragraphPositionsData;
            }

            useClipboardChecklistSectionGenerator(
                copiedSection,
                allRows,
                allCriteria,
                true,
                numParagraphs,
                numParagraphColumns,
                cellTextToParagraphs,
                section.displayParagraphColumns
            );
        }
    }
};